'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:tower:shareConfig');
}

var _invoke = require('../invoke');

/**
 * Webview 页面分享功能
 *
 * 在App中将页面分享到微信、朋友圈、微博
 *
 * 支持版本
 * + iTower/1.3+
 *
 * @memberof tower
 * @static
 * @name shareConfig
 * @param {String} name
 * @param {Object} opts
 * @return {Promise<string | err>}
 * @example
 *  hbnb.tower.shareConfig('weixin', {
 *      title: '页面名称',
 *      desc: '内容',
 *      imgUrl: 'http://xxx.jpg',
 *      link: 'http://www.com',
 *  }).then().catch();
 */

module.exports = function(name, data) {
    return new Promise(function(resolve, reject) {
        _invoke('tower', 'share_config_' + name, {
            title: data.title,
            desc: data.desc,
            imgUrl: data.imgUrl,
            link: data.link,
            callback: function(result) {
                if (process.env.NODE_ENV !== 'production') {
                    debug('share_config result is %j', result);
                }
                resolve(result);
            },
            errback: reject
        });
    });
};




//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/tower/share-config.js
// module id = 419
// module chunks = 1 12 14